"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const DataJoinerNodeValidation_1 = require("../validations/DataJoinerNodeValidation");
class DataJoinerNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.DataJoiner };
    if (props.type !== types_1.NODE_TYPES.DataJoiner)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    return data;
  }
  serialize(uiData) {
    return uiData;
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  validate() {
    return new DataJoinerNodeValidation_1.DataJoinerNodeValidation().validate(
      this
    );
  }
  async getAvailableResources() {
    return [
      {
        selectedResourceId: this.getNodeId(),
        label: [this.getNodeName(), "Data"].join("."),
        nodeRef: this,
        path: "",
        context: {
          outputPath: ""
        }
      }
    ];
  }
  async getOutputKeys(params) {
    const { data, workflow, resource } = params || {};
    if (!workflow) return [];
    const nodeData = data || this.getNodeData();
    if (!nodeData) return [];
    const resources = await workflow.getAllAvailableResources(this);
    const filteredResources = resources.filter(x => Boolean(x.nodeRef));
    const { rightData, leftData } = nodeData;
    const leftResource = filteredResources.find(
      res =>
        // @ts-ignore
        ["$wf", res.nodeRef.getNodeId(), res.path]
          .join(".")
          .replace(/\.$/, "") === leftData
    );
    // @ts-ignore
    const rightResource = filteredResources.find(
      res =>
        // @ts-ignore
        ["$wf", res.nodeRef.getNodeId(), res.path]
          .join(".")
          .replace(/\.$/, "") === rightData
    );
    const leftNodeKey = leftResource
      ? await workflow.getOutputKeysOfSelectedResource(leftResource)
      : [];
    const rightNodeKey = rightResource
      ? await workflow.getOutputKeysOfSelectedResource(rightResource)
      : [];
    if (!leftNodeKey && !rightNodeKey) return [];
    return leftNodeKey.concat(rightNodeKey);
  }
}
exports.DataJoinerNode = DataJoinerNode;
//# sourceMappingURL=DataJoinerNode.js.map
